import Tab from '~/components/ui/Tab';
import { TabListType } from '~/components/ui/Tab/Tab';
import { getTranslationKey, MultiApplicationTabs } from './utils';
import { useNavigate, useParams } from '@solidjs/router';
import {
  EnvironmentPagePath,
  getSlug,
  replacePathParams
} from '~/components/AppRouter/utils';
import { useAppData } from '~/components/AppData';
import ConfigureMultiApp from './ConfigureMultiApp';
import { Localized } from '~/i18n';
import { ApiConfigData } from '~/api';
import { RedirectUriFlowTypes } from '../FullStackAuthentication/Redirects/utils';
import RedirectUriList from '../FullStackAuthentication/Redirects/RedirectUriList';
import { mergeProps } from 'solid-js';

type MultiApplicationDetailsTabsProps = {
  applicationData: ApiConfigData;
};

export default function MultiApplicationDetailsTabs(
  props: MultiApplicationDetailsTabsProps
) {
  const merged = mergeProps({}, props);
  const params = useParams();
  const navigate = useNavigate();
  const appData = useAppData();

  const tabList: TabListType[] = [
    {
      id: MultiApplicationTabs.CONFIGURATION,
      label: (
        <span class={`text-sm`}>
          <Localized
            translationKey={getTranslationKey('tab_header_configuration')}
          />
        </span>
      ),
      content: () => (
        <ConfigureMultiApp applicationData={merged.applicationData} />
      ),
      dataTestId: 'multi-application-details-configuration-tab'
    },
    {
      id: MultiApplicationTabs.REDIRECT,
      label: (
        <Localized translationKey={getTranslationKey('tab_header_redirects')} />
      ),

      content: () => (
        <RedirectUriList
          clientCredentials={[merged.applicationData]}
          flowType={RedirectUriFlowTypes.MULTI_APPLICATION}
        />
      ),
      dataTestId: 'multi-application-details-redirects-tab'
    }
  ];

  const handleTabValueChange = (tabType: MultiApplicationTabs) => {
    navigate(
      getSlug.environmentById(
        appData.selectedEnvironment?.id,
        replacePathParams(
          EnvironmentPagePath.ENVIRONMENT_MULTI_APPLICATION_TABS,
          {
            applicationId: params.applicationId,
            tabType
          }
        ) as EnvironmentPagePath,
        true
      )
    );
  };

  return (
    <div class={`mt-4 flex-grow`}>
      <Tab
        lazyMount
        list={tabList}
        value={params.tabType}
        onValueChange={({ value }) =>
          handleTabValueChange(value as MultiApplicationTabs)
        }
        unmountOnExit
      />
    </div>
  );
}
